export type DrawerUnit = 'percent' | 'pixel';
export type DrawerMode = 'side-preview' | 'side-drawer';

export interface DrawerSizeConfig {
  width: number;
  unit: DrawerUnit;
}

export interface DrawerDragConfig {
  enabled: boolean;
}

export interface DrawerResponsiveConfig {
  closeOnScreenSizes: string[];
}

export interface DrawerLayoutConfig {
  mode: DrawerMode;
  overlay?: boolean;
}

interface BaseDrawerOptions {
  drag?: Partial<DrawerDragConfig>;
  responsive?: Partial<DrawerResponsiveConfig>;
}

export interface SidePreviewOptions extends BaseDrawerOptions {
  layout: DrawerLayoutConfig & { mode: 'side-preview' };
  size?: Partial<DrawerSizeConfig>;
}

export interface SideDrawerOptions extends BaseDrawerOptions {
  layout: DrawerLayoutConfig & { mode: 'side-drawer' };
  size: DrawerSizeConfig;
}

export type DrawerOptions = SidePreviewOptions | SideDrawerOptions;

export const DEFAULT_DRAWER_CONFIG = {
  layout: {
    mode: 'side-preview',
    overlay: false,
  },
  responsive: {
    closeOnScreenSizes: ['small', 'extra-small'],
  },
} as DrawerOptions;

export const DEFAULT_SIDE_DRAWER_CONFIG = {
  layout: { mode: 'side-drawer' },
  size: { width: 400, unit: 'pixel' },
  responsive: { closeOnScreenSizes: ['small', 'extra-small', 'medium'] },
} as SideDrawerOptions;
